<template>
  <div id="login">
      <div class="container" style="padding:100px 0px 30px 0px;">
        <div class="row justify-content-center align-items-center">
          <div class="card" style="padding: 20px">
            <article class="card-body">
              <h4 @click="redirectURL({name: 'home'})" class="card-title text-center mb-4 mt-1">
                <img src="/img/logotipo-pubtec.png" height="70"/>
              </h4>
              <hr>
              <!--<p class="text-success text-center">Some message goes here</p>-->
              <form>
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> <i class="fa fa-user"></i> </span>
                    </div>
                    <input name="email" v-on:keyup.enter="goLogin()" class="form-control" v-model="user.name" placeholder="Email" type="email">
                  </div> <!-- input-group.// -->
                  <span class="errorForm errorName"></span>
                </div> <!-- form-group// -->
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input name="password" v-on:keyup.enter="goLogin()" class="form-control" v-model="user.password" placeholder="******" type="password">
                  </div> <!-- input-group.// -->
                  <span class="errorForm errorPass"></span>
                </div> <!-- form-group// -->
                <div class="form-group">
                  <a @click="goLogin()" class="btn btn-primary btn-block"> Entrar  </a>
                </div> <!-- form-group// -->
                <p class="text-center"><small><a href="#" @click="restorePass()">Esqueci minha senha</a></small></p>
              </form>
            </article>
          </div> <!-- card.// -->
        </div>
      </div><!-- /container -->
        <!-- Small modal -->
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="loginRestore" id="loginRestore" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Recuperação de senha</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Um e-mail com um link de recuperação será enviado para você. Informe seu email:</p>
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"> <i class="fa fa-user"></i> </span>
            </div>
            <input name="email" class="form-control" v-model="user.name" placeholder="Email" type="email">
          </div> <!-- input-group.// -->
          <span class="errorForm errorRestore"></span>
        </div> <!-- form-group// -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-secondary" @click="goNewPass()">Recuperar senha</button>
      </div>
        </div>
      </div>
    </div>
    <footer-default/>
  </div>
</template>

<script>
  import auth from '../api/auth'
  import user from "../api/user"
  import mixins from "../helpers/mixins";
  import store from "../store/store"
  import footerDefault from "./common/footer-default"

  export default {
    name: "Login",
    mixins: [mixins],
    data () {
      return {
        user: {
          name: '',
          password: ''
        },
      }
    },
    components: { footerDefault },
    methods: {
      goLogin(){
        $('.errorForm').html('')
        if(this.user.password === '' || this.user.name === ''){
          if(this.user.password === '')
            $('.errorPass').html('Esse campo precisa ser preenchido')
          if(this.user.name === '')
            $('.errorName').html('Esse campo precisa ser preenchido')
        } else {
            auth.getToken({ username: this.user.name, password: this.user.password }).then((response) => {
              user.list(1, this.user.name).then((response_user) => {
                let user_data = response_user.data.results[0]
                this.$store.commit('setUser', user_data)
              })
              this.$store.commit('setToken', response.data.access)
              let currentPage = localStorage.getItem('currentPage')
              if(currentPage){
                this.$router.push({name: currentPage})
              } else {
                this.$router.push({name: 'home'})
              }
            })
          }
      },
      goNewPass(){
        if(this.user.name == ''){
          $('.errorRestore').html('O e-mail precisa ser preenchido')
        } else {
          store.commit('setLoading', true)
          auth.changePassword({email: this.user.name}).then((response) => {
            if(response.status == 200){
              $('.modal-body').html('<p>Enviamos um e-mail para recuperação da senha.</p>')
              $('.modal-footer').html('<button type="button" class="btn btn-secondary  okButn" onclick="location.reload();">Ok</button>')
            }
            store.commit('setLoading', false)
          }).catch(errors => {
            $('.errorRestore').html('Não foi encontrada uma conta cadastrada com esse e-mail')
            console.log(errors)
            store.commit('setLoading', false)
          })
        }
      },
      restorePass(){
        $('#loginRestore').modal('show')
      }
    }
  }
</script>

<style scoped>
  form{ min-width: 300px; }
</style>
